import { showSnackbar, snackbarSuccess, snackbarError } from './snackbar';

function stripHtml(text) {
  if (typeof text !== 'string') return '';
  return text.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
}

function resolveMessageArg(args) {
  const message = args.find((arg) => typeof arg === 'string');
  return message || '';
}

const BACKEND_UNREACHABLE_COOLDOWN_MS = 30_000;
let lastBackendUnreachableNotifyAt = 0;

function isBackendUnreachableMessage(message) {
  if (typeof message !== 'string') return false;
  return message.includes('Backend nicht erreichbar');
}

function shouldSuppressBackendUnreachableNotify(message) {
  if (!isBackendUnreachableMessage(message)) return false;
  const now = Date.now();
  if (now - lastBackendUnreachableNotifyAt < BACKEND_UNREACHABLE_COOLDOWN_MS) {
    return true;
  }
  lastBackendUnreachableNotifyAt = now;
  return false;
}

export function extractErrorMessage(error) {
  if (typeof error === 'string') return error;
  if (error?.response?.data?.message) return error.response.data.message;
  if (error?.message) return error.message;
  return 'Ein unbekannter Fehler ist aufgetreten';
}

export const notify = async (message) => {
  const text = stripHtml(message);
  if (!text || shouldSuppressBackendUnreachableNotify(text)) return null;
  return showSnackbar(text);
};

export const notifySuccess = (...args) => {
  const message = stripHtml(resolveMessageArg(args));
  return snackbarSuccess(message || 'Erfolgreich gespeichert');
};

export const notifyError = (...args) => {
  const first = args[0];
  if (typeof first === 'string' && args.length === 1) {
    if (shouldSuppressBackendUnreachableNotify(first)) return null;
    return snackbarError(first);
  }
  const errorArg = args.find((arg) => arg && typeof arg === 'object') || first;
  if (errorArg && typeof errorArg !== 'string') {
    // eslint-disable-next-line no-console
    console.error(errorArg);
  }
  const message = extractErrorMessage(errorArg);
  if (shouldSuppressBackendUnreachableNotify(message)) return null;
  return snackbarError(message);
};

export default {
  notify,
  notifyError,
  notifySuccess,
};
